export default {"src":"/_next/static/media/bg_mint_m.064b5a41.svg","height":725,"width":639,"blurWidth":0,"blurHeight":0};